import { render } from "./assignLeads.vue?vue&type=template&id=5307ca74&scoped=true"
import script from "./assignLeads.vue?vue&type=script&lang=js"
export * from "./assignLeads.vue?vue&type=script&lang=js"

import "./assignLeads.vue?vue&type=style&index=0&id=5307ca74&scoped=true&lang=css"
import "./assignLeads.vue?vue&type=style&index=1&id=5307ca74&lang=css"
script.render = render
script.__scopeId = "data-v-5307ca74"

export default script